{
  "dashboard": {
    "Cargas de carta": "Menu page views",
    "Tráfico QR": "QR Traffic",
    "Aperturas / carga": "Opens per view",
    "Acciones de contacto": "Contact Actions",
    "Carta pública": "Public menu",
    "Últimos 15 días · todas las sucursales": "Last 15 days · all branches",
    "Ver analítica →": "See analytics →",
    "Gestionar menú →": "Manage menu →",
    "Añade platos a la carta para controlar su disponibilidad desde aquí.": "Add dishes to the menu to control their availability from here.",
    "Disponibilidad de la carta": "Menu availability",
    "Disponibilidad de {{name}}": "Availability for {{name}}",
    "Disponible": "Available",
    "Oculto": "Hidden",
    "Estado del servicio": "Service Status",
    "últimos 12 meses": "last 12 months",
    "últimos 30 días": "last 30 days",
    "Visitas registradas": "Visits recorded",
    "Primeras visitas": "First visits",
    "Visitas recurrentes": "Recurring visits",
    "Tarjetas activas": "Active cards",
    "Visita repetida": "Repeat visit",
    "Visitas": "Visits",
    "Periodo de visitas": "Visiting period",
    "30 días": "30 days",
    "12 meses": "12 months",
    "Visitas nuevas y recurrentes durante el periodo seleccionado": "New and recurring visits during the selected period",
    "Cuando tus clientes registren su primera visita, la tendencia aparecerá aquí.": "The trend will appear here after your customers record their first visit.",
    "primeras visitas ·": "first visits ·",
    "recurrentes": "recurring",
    "Cargando visitas": "Loading visits",
    "Sin dominio público todavía.": "No public domain yet.",
    "Panel diario · {{branch}}": "Daily overview · {{branch}}",
    "Panel diario": "Daily Dashboard",
    "Resumen": "Summary",
    "Tasa VES": "VES rate",
    "Cambia solo. Compártelo para que tus clientes sumen sellos.": "The code rotates automatically. Share it so customers can collect stamps.",
    "Código de la sucursal": "Branch code",
    "Gestionar promociones →": "Manage promotions →",
    "No hay promociones activas ni programadas.": "No active or scheduled promotions.",
    "Promociones": "Promotions",
    "Ver carta ↗": "View menu ↗",
    "Código QR": "QR code"
  },
  "main.tsx": {
    "Unable to find root element": "Unable to find root element"
  },
  "routes": {
    "Crea una sucursal para generar su QR y su carta.": "Create a branch to generate its QR code and menu.",
    "El QR y la carta necesitan un dominio. Contacta con QMenut para asignarlo.": "The QR code and menu need a domain. Contact QMenut to assign one.",
    "Código QR": "QR Code",
    "Carta para imprimir": "Printable menu",
    "QR y carta impresa": "QR code and printed menu",
    "Material para tu local": "Material for your premises",
    "QR para mesas": "Table QRs",
    "Folletos y carteles": "Flyers & posters",
    "Carta impresa": "Printed menu",
    "Material para imprimir": "Print materials",
    "Prepara los QR y la carta de tu local. Elige el formato y comprueba cómo quedará antes de imprimir.": "Prepare QR codes and menus for your venue. Choose a format and check the preview before printing."
  },
  "shell": {
    "Resumen": "Summary",
    "Analítica": "Analytics",
    "Menú": "Menu",
    "Promociones": "Promotions",
    "Fidelización": "Loyalty",
    "Tema": "Theme",
    "Idiomas": "Languages",
    "Código QR": "QR Code",
    "Sucursal": "Branch",
    "Usuarios": "Users",
    "Ruta": "Path",
    "Restaurante activo": "Active restaurant",
    "Navegación del panel": "Dashboard Navigation",
    "Cerrar navegación": "Close navigation",
    "Ocultar navegación": "Hide navigation",
    "Mostrar navegación": "Show navigation",
    "Cancelar": "Cancel",
    "Descartar cambios": "Discard changes",
    "¿Descartar cambios?": "Discard changes?",
    "Sin dominio público": "Not public domain",
    "Sucursal activa": "Active Branch",
    "Ver carta ↗": "View menu ↗",
    "Cerrar sesión": "Sign out",
    "Instalar app": "Install app",
    "Material para imprimir": "Print materials",
    "Notificaciones": "Notifications",
    "Mensajería": "Messaging",
    "Reservas": "Reservations",
    "Instalar QMenut": "Install QMenut",
    "Se abre como una app y recibe notificaciones en este dispositivo.": "Opens like an app and receives notifications on this device.",
    "Toca Compartir y luego «Añadir a pantalla de inicio».": "Tap Share, then “Add to Home Screen”.",
    "En la barra de menús, elige Archivo → «Añadir al Dock».": "In the menu bar, choose File → “Add to Dock”.",
    "Abre el menú del navegador y elige «Instalar app» o «Añadir a pantalla de inicio». En ordenador también aparece un icono de instalar en la barra de direcciones.": "Open the browser menu and choose “Install app” or “Add to Home Screen”. On a computer there is also an install icon in the address bar.",
    "Entendido": "Got it"
  },
  "analytics": {
    "Sin datos en este periodo.": "No data in this period.",
    "Mapa": "Map",
    "Teléfono": "Telephone",
    "Redes sociales": "Social networks",
    "WhatsApp": "WhatsApp",
    "Todos": "All",
    "Aún no hay suficientes cargas en ambos periodos para extraer comparaciones fiables. Necesitamos al menos 20 cargas por periodo.": "There are not enough page views in either period to make a reliable comparison. At least 20 page views per period are required.",
    "No hay cambios destacados que señalar en este periodo.": "There are no notable changes to note in this period.",
    "Mejora": "Upgrade",
    "Oportunidad": "Opportunity",
    "Resumen de analítica": "Analytics Summary",
    "Cargas de carta": "Menu page views",
    "Páginas cargadas, todas las sucursales": "Menu page views across all branches",
    "Visitas efímeras": "Ephemeral visits",
    "No son clientes únicos": "These are not unique customers.",
    "Aperturas / carga": "Opens per view",
    "Puede superar 1×": "Can exceed 1×",
    "Tráfico QR": "QR Traffic",
    "Cargas atribuidas al enlace QR": "Menu views from QR links",
    "Acciones de contacto": "Contact Actions",
    "Toques registrados": "Registered touches",
    "Datos del {{range}} · agregados para todas las sucursales.": "Data for {{range}} · aggregated across all branches.",
    "Analítica": "Analytics",
    "Qué está pasando en tu carta": "What is happening in your menu",
    "Comparación": "Comparison",
    "Frente al periodo anterior": "Compared to the previous period",
    "Sin periodo anterior": "No previous period",
    "Periodo de analítica": "Analysis period",
    "Lecturas": "Readings",
    "Señales para decidir qué revisar a continuación.": "Signs to decide what to review next.",
    "Tráfico": "Traffic",
    "Cómo llega la gente y cuándo abre la carta.": "How people find your menu and when they open it.",
    "Todas las sucursales": "All branches",
    "Carta instalada": "Installed menu",
    "Uso en modo PWA": "Use in PWA mode",
    "Sumadas por bloque analítico": "Summed by analytical block",
    "Idiomas": "Languages",
    "Sucursales": "Branches",
    "Sucursal sin nombre": "Untitled branch",
    "Horas punta": "Peak hours",
    "No hay horas punta disponibles todavía.": "No peak times available yet.",
    "cargas": "views",
    "Menú": "Menu",
    "Qué contenido despierta más interés.": "Which content arouses the most interest.",
    "Aperturas registradas": "Recorded opens",
    "Aperturas de platos": "Dish views",
    "Desde destacados": "From Featured",
    "Desde secciones": "From sections",
    "Platos más abiertos": "More open dishes",
    "Las aperturas de platos aparecerán aquí.": "Dish views will appear here.",
    "{{count}} por carga": "{{count}} per page view",
    "Categorías": "Categories",
    "Categorías alcanzadas": "Categories reached",
    "Selecciones": "Selections",
    "Mayor profundidad": "Greater depth",
    "Promociones": "Promotions",
    "aperturas en total": "total opens",
    "Las aperturas de promociones aparecerán aquí.": "Promotion views will appear here.",
    "Promoción sin nombre": "Untitled promotion",
    "Contacto y PWA": "Contact and PWA",
    "Acciones que acercan la carta al negocio.": "Tools that help bring more customers to your menu.",
    "Contactos": "Contacts",
    "Instalaciones": "Installations",
    "Prompt aceptado": "Prompt accepted",
    "Prompt descartado": "Prompt discarded",
    "Canales de contacto": "Contact channels",
    "Las acciones de contacto aparecerán aquí.": "Contact actions will appear here.",
    "Son toques registrados: no confirman que una llamada, mensaje o ruta se haya completado.": "These are registered touches: they do not confirm that a call, message or route has been completed.",
    "Fidelización y premios": "Loyalty and rewards",
    "Actividad de clientes identificados en D1.": "Activity of customers identified in D1.",
    "Ver clientes →": "See customers →",
    "Clientes con visita": "Customers with visit",
    "Visita repetida": "Repeat visit",
    "Regresan en 30 días": "Return in 30 days",
    "Tarjetas activas": "Active cards",
    "Tarjetas inactivas": "Inactive cards",
    "Intervalo mediano": "Median interval",
    "Sellos acumulados": "Accumulated stamps",
    "Premios en el periodo": "Rewards during this period",
    "Solicitados": "Requested",
    "Validados": "Validated",
    "Pendientes": "Earrings",
    "Rechazados": "Rejected",
    "Expirados": "Expired",
    "Tiempo al primer premio": "Time to first reward",
    "Coste estimado": "Estimated cost",
    "Configura el ticket medio": "Configure the average ticket",
    "{{count}} días": "{{count}} days",
    "{{count}} h": "{{count}} hr",
    "Sin comparación": "No comparison",
    "Sin base comparable": "No comparable base",
    "Sin cambio": "No change",
    "{{count}} p.p.": "{{count}} pp",
    "15 días": "15 days",
    "30 días": "30 days",
    "90 días": "90 days"
  },
  "auth": {
    "Verificando…": "Verifying…",
    "Development usa el código fijo {{code}}.": "Development uses the fixed code {{code}}.",
    "Introduce el código enviado a {{email}}.": "Enter the code sent to {{email}}.",
    "Entrar": "Enter",
    "Preparando…": "Preparing…",
    "Introduce el email de una cuenta provisionada.": "Enter the email of a provisioned account.",
    "Continuar": "Continue",
    "Solicitando…": "Requesting…",
    "Solicita un código de acceso.": "Request an access code.",
    "Solicitar código": "Request code",
    "QMenut Admin": "QMenut Admin",
    "Email": "Email",
    "nombre@turestaurante.com": "name@turestaurante.com",
    "Código OTP": "OTP Code",
    "¿No te llegó el código?": "Did you not receive the code?",
    "Reenviar en {{seconds}}s": "Resend in {{seconds}}s",
    "Reenviar código": "Resend code",
    "Propietario": "Owner",
    "Administrador": "Administrator",
    "Equipo": "Equipment",
    "Elige un restaurante": "Choose a restaurant",
    "Tu cuenta tiene acceso a varios restaurantes. Selecciona con cuál quieres trabajar.": "Your account has access to several restaurants. Select which one you want to work with.",
    "Tu cuenta no tiene acceso a ningún restaurante. Contacta con soporte para configurarlo.": "Your account does not have access to any restaurants. Contact support to configure it.",
    "Cerrando sesión…": "Signing out…",
    "Cerrar sesión": "Sign out",
    "Introduce un email válido": "Please enter a valid email",
    "Introduce el código de 6 dígitos": "Enter the 6-digit code"
  },
  "billing": {
    "En prueba": "In testing",
    "Activa": "Active",
    "Pago pendiente": "Pending payment",
    "Cancelada": "Cancelled",
    "Básico": "Basic",
    "Facturación": "Billing",
    "Suscripción": "Subscription",
    "Sin suscripción": "No subscription",
    "Cancelación programada.": "Scheduled cancellation.",
    "Gestionar {{branch}} en Stripe": "Manage {{branch}} in Stripe",
    "Gestionar en Stripe": "Manage in Stripe",
    "{{plan}} para {{branch}}": "{{plan}} for {{branch}}",
    "Business": "Business",
    "Cambiar a {{plan}}": "Switch to {{plan}}",
    "Con varias sucursales, cada una necesita el plan Business.": "With several branches, each one needs the Business plan.",
    "Probar {{plan}} 14 días": "Try {{plan}} for 14 days",
    "Suscribir {{plan}}": "Subscribe to {{plan}}"
  },
  "branch": {
    "useBranchForm debe usarse dentro de BranchFormProvider": "useBranchForm must be used inside BranchFormProvider",
    "Buscando direcciones…": "Searching for addresses…",
    "Obteniendo la ubicación…": "Getting location…",
    "No se pudo obtener la ubicación del mapa. Puedes guardar la dirección sin mapa.": "Could not get map location. You can save the address without map.",
    "Has alcanzado el límite de búsquedas. Espera un minuto antes de continuar.": "You have reached your search limit. Wait a minute before continuing.",
    "No se pudo buscar ahora. Puedes guardar la dirección sin mapa.": "Could not search now. You can save the address without map.",
    "No hay resultados para esta búsqueda.": "There are no results for this search.",
    "Dirección": "Address",
    "Ubicación del mapa vinculada": "Linked map location",
    "Quitar ubicación del mapa": "Remove location from map",
    "Selecciona una sugerencia para mostrar esta sucursal en el mapa público.": "Select a suggestion to show this branch on the public map.",
    "Reseñas de Google": "Google Reviews",
    "Conecta la ficha exacta de esta sucursal. Google elige y ordena las reseñas que aparecen en la página de contacto.": "Connect this branch’s exact Google listing. Google chooses and orders the reviews shown on the contact page.",
    "Ficha de Google Maps conectada": "Connected Google Maps tab",
    "La conexión se guarda por sucursal.": "The connection is saved per branch.",
    "Abrir en Google Maps ↗": "Open in Google Maps ↗",
    "Cambiar": "Change",
    "Desconectar": "Disconnect",
    "Buscar negocio o ficha": "Search for business or listing",
    "Nombre y dirección de la sucursal": "Branch name and address",
    "Buscando…": "Searching…",
    "Buscar": "Search",
    "No se encontraron fichas para esta búsqueda.": "No records found for this search.",
    "Sin valoración": "No rating",
    " · {{count}} reseñas": " · {{count}} reviews",
    "Conectar esta ficha": "Connect this tab",
    "Mostrar reseñas en la página de contacto": "Show reviews on contact page",
    "Conecta una ficha antes de activar las reseñas.": "Connect a token before turning on reviews.",
    "Redes sociales": "Social networks",
    "Red social": "Social network",
    "https://instagram.com/tucuenta": "https://instagram.com/tucuenta",
    "Quitar red social {{index}}": "Remove social link {{index}}",
    "Quitar": "Remove",
    "Agregar red social": "Add social network",
    "Se muestran como iconos en la página de contacto del menú público. El icono se detecta a partir del enlace.": "They are displayed as icons on the contact page in the public menu. The icon is detected from the link.",
    "No se pudo preparar el logo.": "Could not prepare logo.",
    "Datos guardados.": "Saved data.",
    "General": "General",
    "Galería": "Gallery",
    "Horario": "Schedule",
    "Legal": "Legal",
    "No hay ninguna sucursal disponible.": "There are no branches available.",
    "Sucursal": "Branch",
    "Secciones de la sucursal": "Branch Sections",
    "Galería de la sucursal": "Branch gallery",
    "Identidad y contacto": "Identity and contact",
    "Nombre": "Name",
    "Teléfono": "Telephone",
    "WhatsApp": "WhatsApp",
    "Zona horaria del restaurante": "Restaurant time zone",
    "Imágenes públicas": "Public Images",
    "Logo (icono de la app)": "Logo (app icon)",
    "Datos legales del titular": "Legal details of the owner",
    "Razón social": "Company name",
    "NIF/CIF": "NIF/CIF",
    "Email de protección de datos": "Data protection email",
    "Estos datos aparecen en el aviso legal y la política de privacidad públicos; complétalos antes de publicar. El domicilio fiscal es la dirección de la sucursal que defines en la pestaña General.": "This data appears in the public legal notice and privacy policy; complete them before publishing. The tax address is the address of the branch that you define in the General tab.",
    "Horario semanal": "Weekly Schedule",
    "{{count}} franja": "{{count}} time slot",
    "{{count}} franjas": "{{count}} time slots",
    "Apertura {{day}}": "{{day}} opening time",
    "Cierre {{day}}": "{{day}} closing time",
    "Quitar franja {{position}} de {{day}}": "Remove time slot {{position}} from {{day}}",
    "Añadir franja": "Add time slot",
    "Añadir horario": "Add schedule",
    "Lunes": "Monday",
    "Martes": "Tuesday",
    "Miércoles": "Wednesday",
    "Jueves": "Thursday",
    "Viernes": "Friday",
    "Sábado": "Saturday",
    "Domingo": "Sunday",
    "España peninsular — Madrid": "Peninsular Spain — Madrid",
    "España — Islas Canarias": "Spain — Canary Islands",
    "Portugal — Lisboa": "Portugal — Lisbon",
    "Reino Unido — Londres": "United Kingdom — London",
    "Francia — París": "France — Paris",
    "Alemania — Berlín": "Germany — Berlin",
    "Italia — Roma": "Italy — Rome",
    "Países Bajos — Ámsterdam": "Netherlands — Amsterdam",
    "Bélgica — Bruselas": "Belgium — Brussels",
    "Suiza — Zúrich": "Switzerland — Zurich",
    "Grecia — Atenas": "Greece — Athens",
    "EE. UU. — Nueva York": "US — New York",
    "EE. UU. — Chicago": "US—Chicago",
    "EE. UU. — Denver": "US—Denver",
    "EE. UU. — Los Ángeles": "US — Los Angeles",
    "México — Ciudad de México": "Mexico — Mexico City",
    "Colombia — Bogotá": "Colombia — Bogotá",
    "Argentina — Buenos Aires": "Argentina — Buenos Aires",
    "UTC": "UTC",
    "Hora no válida": "Invalid time",
    "URL no válida": "Invalid URL",
    "{{label}} no válida": "{{label}} is invalid",
    "{{label}} fuera de rango": "{{label}} is out of range",
    "El nombre es obligatorio": "Name is required",
    "Latitud": "Latitude",
    "Longitud": "Length",
    "La URL debe empezar por https://": "The URL must begin with https://",
    "Máximo 10 redes sociales": "Maximum 10 social networks",
    "Email no válido": "Invalid email",
    "La zona horaria es obligatoria": "Time zone is required",
    "Selecciona una dirección para completar la ubicación del mapa": "Select an address to complete the map location",
    "En el plan Básico la carta muestra solo la foto de portada. La galería es del plan Business.": "On the Basic plan the menu shows only the cover photo. The gallery is part of the Business plan."
  },
  "shared": {
    "Optional": "Optional",
    "primeras visitas": "first visits",
    "Selecciona…": "Select…",
    "Preparando subida…": "Preparing upload…",
    "Guardando datos…": "Saving data…",
    "100 % transferido. Confirmando recepción…": "100% transferred. Confirming receipt…",
    "Subiendo archivos… {{percentage}} %": "Uploading files… {{percentage}}%",
    "Transferencia de archivos": "File Transfer",
    "Espera a que termine el guardado antes de salir.": "Wait for the save to finish before exiting.",
    "Guardando…": "Saving…",
    "Guardar": "Save",
    "Cancelar": "Cancel",
    "No hay resultados": "No results",
    "Buscar": "Search",
    "{{label}}: selector": "{{label}}: picker",
    "Error": "Error",
    "No hemos podido cargar esta vista.": "We couldn’t load this view.",
    "Reintentar": "Retry",
    "Volver al resumen": "Return to summary",
    "Cargando {{title}}": "Loading {{title}}",
    "Cargando": "Loading",
    "Sin sucursal": "No branch",
    "Sin dominio": "No domain",
    "Esta página no existe.": "This page does not exist.",
    "Comprueba la dirección o vuelve al panel principal.": "Check the address or return to the main panel.",
    "Claro": "Clear",
    "Oscuro": "Dark",
    "Tema del panel": "Dashboard Theme",
    "Solo cambia cómo ves QMenut en este dispositivo.": "Only changes how you view QMenut on this device.",
    "Categoría": "Category",
    "Plato": "Dish",
    "Extra": "Extra",
    "Grupo de variantes": "Variant Group",
    "Variante": "Variant",
    "Promoción": "Promotion",
    "Sucursal": "Branch",
    "Recompensa": "Reward",
    "Descripción": "Description",
    "Nombre": "Name",
    "Eslogan": "Slogan",
    "La traducción automática usa catalán. Puedes adaptar aquí los textos al valenciano.": "Automatic translation uses Catalan. You can edit the text here to adapt it to Valencian.",
    "Buscar texto": "Search text",
    "Secciones": "Sections",
    "Traducción guardada.": "Translation saved.",
    "No se encontraron las tipografías del menú.": "The menu fonts were not found.",
    "Apio": "Celery",
    "Crustáceos": "Crustaceans",
    "Huevos": "Eggs",
    "Pescado": "Fish",
    "Gluten": "Gluten",
    "Altramuces": "Lupin",
    "Leche": "Milk",
    "Moluscos": "Molluscs",
    "Mostaza": "Mustard",
    "Frutos de cáscara": "Nuts",
    "Cacahuetes": "Peanuts",
    "Sésamo": "Sesame",
    "Soja": "Soy",
    "Sulfitos": "Sulphites",
    "Introduce un importe válido": "Please enter a valid amount",
    "Conecta una ficha de Google antes de generar este QR.": "Connect a Google token before generating this QR.",
    "No se pudo transferir el archivo. Pulsa Guardar para reintentar.": "The file could not be transferred. Press Save to retry.",
    "No se pudo subir el archivo. Comprueba tu conexión y pulsa Guardar.": "The file could not be uploaded. Check your connection and press Save.",
    "La subida tardó demasiado. Pulsa Guardar para reintentar.": "The upload took too long. Press Save to retry.",
    "Subida interrumpida": "Upload interrupted",
    "Los cambios sin guardar se perderán.": "Unsaved changes will be lost.",
    "Platos": "Dishes",
    "Extras": "Extras",
    "Promociones": "Promotions",
    "Recompensas": "Rewards",
    "Borrar búsqueda": "Clear search",
    "Filtrar textos": "Filter texts",
    "Todos ({{count}})": "All ({{count}})",
    "Pendientes ({{count}})": "Pending ({{count}})",
    "Modificados ({{count}})": "Edited ({{count}})",
    "{{done}}/{{total}} traducidos": "{{done}}/{{total}} translated",
    "No hay textos en esta selección.": "No texts match this selection.",
    "Guardar cambios": "Save changes",
    "Cambios sin guardar: {{count}}": "Unsaved changes: {{count}}",
    "Modificado": "Edited",
    "El original cambió": "Original changed",
    "Pendiente": "Pending",
    "Deshacer": "Undo",
    "Confirmar": "Confirm",
    "No se traducen ({{count}})": "Not translated ({{count}})",
    "No se traduce": "Not translated",
    "Permitir traducción": "Allow translation",
    "No traducir: mantener el texto original en todos los idiomas": "Don't translate: keep the original text in every language",
    "Disponible en Business": "Available on Business",
    "Disponible en el plan Business.": "Available on the Business plan.",
    "Esta sección está incluida en el plan Business. Tus datos se conservan.": "This section is part of the Business plan. Your data is kept.",
    "Ver planes": "See plans"
  },
  "exchangeRates": {
    "Sin referencia disponible": "No reference available",
    "Sin comparación": "No comparison",
    "Tasa VES guardada.": "Saved VES rate.",
    "Precios derivados": "Derived prices",
    "Tasa VES": "VES rate",
    "VES por 1 USD": "VES for 1 USD",
    "Tasa elegida": "Chosen rate",
    "Referencia BCV": "Reference BCV",
    "No disponible": "Not available",
    "Fecha": "Date",
    "Diferencia": "Difference",
    "Todavía no hay una tasa configurada para este restaurante.": "There is no rate set for this restaurant yet.",
    "La referencia de Ming no está disponible en este momento.": "Ming reference is not available at this time.",
    "Mostrar precios en VES": "Show prices in VES",
    "Guardando…": "Saving…",
    "Guardar": "Save",
    "La referencia de Ming es informativa. Los precios públicos usan la tasa elegida por el restaurante.": "Ming's reference is informative. Public prices use the rate chosen by the restaurant.",
    "Introduce una tasa positiva con hasta seis decimales": "Enter a positive rate with up to six decimal places"
  },
  "languages": {
    "Traducciones · {{language}}": "Translations · {{language}}",
    "Idioma añadido, pendiente de traducción: {{error}}": "Language added, translation pending: {{error}}",
    "Idioma añadido y traducido.": "Language added and translated.",
    "Idioma eliminado.": "Language removed.",
    "Traducción actualizada.": "Translation updated.",
    "Idiomas": "Languages",
    "Añadir un idioma traduce el contenido de todas las sucursales. Solo se publica cuando todos los textos están completos. Selecciona un idioma para editar sus traducciones.": "Adding a language translates the content of all branches. It is only published when all the texts are complete. Select a language to edit its translations.",
    "Aún no hay idiomas configurados.": "There are no languages ​​configured yet.",
    "Idiomas disponibles": "Available languages",
    "Publicado": "Published",
    "{{count}} textos pendientes · Sin publicar": "{{count}} pending strings · Unpublished",
    "Por defecto": "Default",
    "Acciones para {{language}}": "Actions for {{language}}",
    "Editar traducciones": "Edit translations",
    "Completar traducciones": "Complete translations",
    "Retraducir contenido": "Translate content again",
    "Eliminar": "Delete",
    "Procesando…": "Processing…",
    "Acciones": "Actions",
    "Añadir idioma": "Add language",
    "Idioma": "Language",
    "Traduciendo…": "Translating…",
    "Añadir y traducir": "Add and translate",
    "Cancelar": "Cancel",
    "Retraducir": "Retranslate",
    "Se retraducirán todos los textos de todas las sucursales en este idioma. También se sobrescribirán tus correcciones manuales. Para conservarlas, usa Completar traducciones.": "All texts from all branches will be retranslated in this language. Your manual corrections will also be overwritten. To keep them, use Complete Translations.",
    "¿Retraducir todo el contenido?": "Retranslate all content?",
    "Elige un idioma": "Choose a language"
  },
  "loyalty": {
    "Buscando solicitudes": "Searching for requests",
    "Reintentar lista": "Retry list",
    "No hay canjes esperando. Las nuevas solicitudes aparecerán aquí.": "There are no redemptions waiting. New requests will appear here.",
    "sellos ·": "seals ·",
    "Validar {{reward}} para {{email}}": "Approve {{reward}} for {{email}}",
    "Validar": "Validate",
    "Rechazar {{reward}} para {{email}}": "Reject {{reward}} for {{email}}",
    "Rechazar": "Reject",
    "Cancelar": "Cancel",
    "Rechazar canje": "Reject redemption",
    "Se rechazará “{{reward}}” para {{email}}.": "“{{reward}}” will be rejected for {{email}}.",
    "Rechazar solicitud": "Reject request",
    "Canjes pendientes (": "Pending redemptions (",
    "Cargando código": "Loading code",
    "Reintentar código": "Retry code",
    "Código actual:": "Current code:",
    "Programa guardado.": "Saved program.",
    "Premio actualizado.": "Reward updated.",
    "Premio creado.": "Reward created.",
    "Premio eliminado.": "Reward deleted.",
    "{{reward}} validado para {{email}}.": "{{reward}} approved for {{email}}.",
    "Deshacer": "Undo",
    "Sucursal": "Branch",
    "Email": "Email",
    "Sellos": "Seals",
    "Visitas": "Visits",
    "Primera visita": "First visit",
    "Última visita": "Last visit",
    "Premios": "Rewards",
    "Insights": "Insights",
    "La salud del programa": "The health of the program",
    "Indicadores de fidelización": "Loyalty indicators",
    "Nuevos y recurrentes": "New and recurring",
    "Clientes": "Customers",
    "Tarjetas activas": "Active cards",
    "Sellos este mes": "Stamps this month",
    "Canjes este mes": "Redemptions this month",
    "Tasa de canje": "Redemption rate",
    "Visita repetida": "Repeat visit",
    "Periodo del gráfico": "Chart period",
    "30 días": "30 days",
    "12 meses": "12 months",
    "Visitas nuevas y recurrentes durante el periodo seleccionado": "New and recurring visits during the selected period",
    "Las primeras visitas aparecerán aquí.": "First visits will appear here.",
    "primeras visitas ·": "first visits ·",
    "visitas recurrentes": "recurring visits",
    "Clientes (": "Customers (",
    "Preparando CSV…": "Preparing CSV…",
    "Exportar CSV": "Export CSV",
    "Buscar por email": "Search by email",
    "Limpiar búsqueda": "Clear search",
    "cliente@ejemplo.com": "customer@example.com",
    "Sin visita en los últimos 30 días": "No visit in the last 30 days",
    "No hay clientes que coincidan con estos filtros.": "No customers match these filters.",
    "Página": "Page",
    "de": "",
    "Anterior": "Previous",
    "Siguiente": "Next",
    "Operativa": "Operations",
    "Programa": "Program",
    "Secciones de fidelización": "Loyalty sections",
    "Crea una sucursal para mostrar el código de fidelización.": "Create a branch to display the loyalty code.",
    "Operativa · {{branch}}": "Operational · {{branch}}",
    "Fidelización": "Loyalty",
    "Cambia automáticamente. No hace falta tocar nada.": "Changes automatically. You don't need to touch anything.",
    "Código de esta sucursal": "Code of this branch",
    "Plato gratis": "Free dish",
    "Descuento porcentual": "Percentage discount",
    "Precio especial": "Special price",
    "Crea una sucursal antes de configurar la fidelización.": "Create a branch before setting up loyalty.",
    "Sellos y premios": "Stamps and rewards",
    "Configuración": "Configuration",
    "Programa activo": "Active program",
    "Ticket medio": "Medium ticket",
    "Guardar configuración": "Save Settings",
    "Crea el primer premio para que los sellos tengan una meta.": "Create the first reward to give customers a stamp goal.",
    "Vista del cliente ·": "Customer View ·",
    "Tu tarjeta": "Your card",
    "{{balance}} de {{target}} sellos": "{{balance}} of {{target}} stamps",
    "sellos": "seals",
    "Eliminar": "Delete",
    "Se eliminará “{{name}}”. Esta acción no se puede deshacer.": "“{{name}}” will be deleted. This action cannot be undone.",
    "este premio": "this reward",
    "Eliminar premio": "Delete reward",
    "activo": "active",
    "inactivo": "inactive",
    "Acciones para {{name}}": "Actions for {{name}}",
    "Editar": "Edit",
    "Desactivar": "Disable",
    "Activar": "Activate",
    "Acciones": "Actions",
    "Editar premio": "Edit reward",
    "Nuevo premio": "New reward",
    "Premio": "Reward",
    "Nombre": "Name",
    "Descripción": "Description",
    "Premio activo": "Active reward",
    "Canje": "Redemption",
    "Tipo": "Type",
    "Coste en sellos": "Cost in stamps",
    "Descuento (%)": "Discount (%)",
    "Plato · todas las sucursales": "Dish · all branches",
    "Guardar premio": "Save reward",
    "Premios canjeados": "Rewards redeemed",
    "customers-file-name": "loyalty-customers",
    "El coste debe ser un número entero de sellos": "The cost must be an integer number of stamps",
    "Indica un porcentaje entre 0 y 100": "Indicates a percentage between 0 and 100",
    "Escribe un nombre para el premio": "Enter a name for the reward",
    "Selecciona un plato": "Select a dish",
    "Indica un porcentaje": "Indicates a percentage",
    "Indica un precio especial": "Indicates a special price",
    "Pedir sellos": "Request stamps",
    "Solicitudes de sellos ({{count}})": "Stamp requests ({{count}})",
    "No hay solicitudes esperando. Si nadie responde, se aceptan solas a las 12 h.": "No requests waiting. Requests nobody answers are accepted automatically after 12 h.",
    "Se acepta sola en {{hours}} h": "Accepted automatically in {{hours}} h",
    "Sellos a aceptar": "Stamps to accept",
    "Un sello menos": "One stamp fewer",
    "Un sello más": "One stamp more",
    "{{quantity}} de {{claimed}}": "{{quantity}} of {{claimed}}",
    "Aceptar": "Accept",
    "Rechazar la solicitud de {{email}}": "Decline the request from {{email}}",
    "Rechazada": "Declined",
    "Aceptada sola": "Accepted automatically",
    "Aceptada {{accepted}} de {{claimed}}": "Accepted {{accepted}} of {{claimed}}",
    "Aceptada": "Accepted",
    "Últimas 24 h ({{count}})": "Last 24 h ({{count}})",
    "{{count}} sellos pedidos a las {{time}}": "{{count}} stamps requested at {{time}}",
    "Deshacer la solicitud de {{email}}": "Undo the request from {{email}}",
    "Solicitud de {{email}} rechazada.": "Request from {{email}} declined.",
    "Máximo de sellos por solicitud": "Maximum stamps per request",
    "Indica un número entre 1 y 10": "Enter a number from 1 to 10",
    "Aceptar la solicitud de {{email}}": "Accept the request from {{email}}",
    "Solicitud de {{email}} aceptada.": "Request from {{email}} accepted."
  },
  "menu": {
    "No se pudo preparar la imagen.": "Could not prepare image.",
    "Contiene alcohol": "Contains alcohol",
    "Sin gluten": "Gluten-free",
    "Sin lactosa": "Lactose free",
    "Novedad": "New",
    "De temporada": "Seasonal",
    "Picante": "Spicy",
    "Vegano": "Vegan",
    "Crea una sucursal para gestionar sus extras.": "Create a branch to manage your extras.",
    "Gestiona los ingredientes opcionales y asígnalos después a cada plato.": "Manage optional ingredients and then assign them to each dish.",
    "Carta": "Menu",
    "Extras": "Extras",
    "Ingredientes opcionales": "Optional ingredients",
    "Revisa el nombre y el precio del extra.": "Check the name and price of the extra.",
    "Extra actualizado.": "Extra updated.",
    "Extra añadido.": "Extra added.",
    "Extra archivado.": "Extra archived.",
    "Catálogo de extras (": "Extras Catalog (",
    "Nombre": "Name",
    "Precio": "Price",
    "Estado": "Status",
    "Acciones": "Actions",
    "Nombre del nuevo extra": "Name of the new extra",
    "Nuevo extra": "New extra",
    "Precio del nuevo extra": "Price of the new extra",
    "Activo": "Active",
    "Añadir": "Add",
    "Guardar": "Save",
    "Cancelar": "Cancel",
    "Editar {{name}}": "Edit {{name}}",
    "Archivar {{name}}": "Archive {{name}}",
    "Nombre de {{name}}": "{{name}} name",
    "Precio de {{name}}": "{{name}} price",
    "Inactivo": "Inactive",
    "Aún no hay extras creados.": "There are no extras created yet.",
    "Archivar extra": "Archive extra",
    "«{{name}}» dejará de aparecer como opción para nuevos platos.": "“{{name}}” will no longer be available for new dishes.",
    "Este extra": "This extra",
    "¿Archivar extra?": "Archive extra?",
    "Crea una sucursal para gestionar su carta.": "Create a branch to manage its menu.",
    "Secciones de la carta": "Menu sections",
    "Menú": "Menu",
    "Crear categoría": "Create category",
    "Crear plato": "Create dish",
    "Gestiona las categorías y los platos de esta sucursal.": "Manage this branch’s categories and dishes.",
    "Categorías": "Categories",
    "Platos": "Dishes",
    "Aún no hay categorías.": "There are no categories yet.",
    "Activa": "Active",
    "Oculta": "Hidden",
    "Aún no hay platos.": "No dishes yet.",
    "Buscar plato": "Search dishes",
    "Ningún plato coincide con la búsqueda.": "No dishes match your search.",
    "Disponibilidad de {{name}}": "Availability for {{name}}",
    "Disponible": "Available",
    "Oculto": "Hidden",
    "Crea una sucursal para editar su carta.": "Create a branch to edit its menu.",
    "Editar categoría": "Edit Category",
    "Nueva categoría": "New category",
    "Categoría": "Category",
    "Descripción": "Description",
    "Imagen de categoría": "Category Image",
    "Categoría activa": "Active category",
    "Datos del plato": "Dish data",
    "Imagen del plato": "Dish image",
    "Visibilidad en la carta": "Menu visibility",
    "Recomendado": "Recommended",
    "Destacado": "Featured",
    "La carta pública muestra un único plato estrella: el primer destacado según el orden de la carta.": "The public menu shows one featured dish: the first featured item in menu order.",
    "Etiquetas, alérgenos y extras": "Labels, allergens and extras",
    "Etiquetas": "Labels",
    "Alérgenos": "Allergens",
    "Editar plato": "Edit dish",
    "Nuevo plato": "New dish",
    "Plato": "Dish",
    "Variante": "Variant",
    "El nombre es obligatorio": "Name is required",
    "Elige una categoría": "Choose a category",
    "Selecciona un plato para editarlo o crea uno nuevo.": "Select a dish to edit it or create a new one.",
    "Selecciona una categoría para editarla o crea una nueva.": "Select a category to edit it or create a new one.",
    "Plato eliminado.": "Dish deleted.",
    "Eliminar plato": "Delete dish",
    "¿Eliminar plato?": "Delete dish?",
    "«{{name}}» se eliminará de la carta. Esta acción no se puede deshacer.": "“{{name}}” will be removed from the menu. This can't be undone.",
    "Plato guardado.": "Dish saved.",
    "Categoría guardada.": "Category saved.",
    "Subir {{name}}": "Move {{name}} up",
    "Bajar {{name}}": "Move {{name}} down",
    "Mostrar solo en un horario": "Show only during a schedule",
    "Días visibles": "Visible days",
    "Desde": "From",
    "Hasta": "Until",
    "Elige al menos un día": "Choose at least one day",
    "La hora es obligatoria": "Time is required",
    "Máximo 60 caracteres": "Maximum 60 characters",
    "Máximo 24 caracteres": "Maximum 24 characters",
    "Añade al menos dos variantes": "Add at least two variants",
    "Tamaño": "Size",
    "Variantes de precio": "Price variants",
    "Este plato tiene variantes de precio": "This dish has price variants",
    "Nombre del grupo": "Group name",
    "15 cm": "15 cm",
    "Quitar variante {{index}}": "Remove variant {{index}}",
    "Quitar": "Remove",
    "Añadir variante": "Add variant",
    "La carta pública muestra las dos primeras variantes junto al nombre y todas en el detalle del plato. Usa etiquetas cortas (15 cm, S, XXL).": "The public menu shows the first two variants next to the name and all of them in the dish details. Use short labels (15 cm, S, XXL).",
    "Las variantes deben tener precios distintos": "Variants must have different prices"
  },
  "menuPrint": {
    "Categorías de la carta": "Menu categories",
    "Preparando las tipografías y la carta…": "Preparing the fonts and the menu…",
    "La carta cabe en una hoja a doble cara.": "The menu fits on a double-sided sheet.",
    "La carta no cabe. Desmarca categorías hasta que quepa; no se recortará ningún plato.": "The menu does not fit. Uncheck categories until it does; no dishes will be cut off.",
    "Selecciona al menos una categoría para imprimir.": "Select at least one category to print.",
    "No se pudo preparar la carta. Recarga la página para volver a intentarlo.": "Could not prepare the menu. Reload the page to try again.",
    "Del menú a la mesa": "From the menu to the table",
    "Carta para imprimir": "Printable menu",
    "Tu plantilla, tus colores y tus fuentes. Sin fotografías y con los precios habituales.": "Your template, your colors and your fonts. Without photographs and with the usual prices.",
    "Formato del papel": "Paper format",
    "A4 a doble cara": "A4 double-sided",
    "Una hoja vertical, anverso y reverso": "One vertical sheet, front and back",
    "Díptico": "Diptych",
    "Una hoja horizontal, cuatro caras A5": "One horizontal sheet, four sides A5",
    "No se pudo cargar el logo. Se imprimirá el nombre del local.": "Could not load the logo. The restaurant name will be printed instead.",
    "Imprimir / Guardar PDF": "Print/Save PDF",
    "Elige A4, escala 100 %, sin encabezados y con gráficos de fondo. Para doble cara, gira por el borde": "Choose A4, 100% scale, no headers and background graphics. For double sided, turn around the edge",
    "largo": "long edge",
    "corto": "short edge",
    ". Para descargar, elige «Guardar como PDF» en el diálogo de impresión.": ". To download, choose “Save as PDF” in the print dialog.",
    "Favorito": "Favorite",
    "Recomendado": "Recommended",
    "Alérgenos": "Allergens",
    "Alérgenos:": "Allergens:",
    "Ver carta online": "View menu online",
    "Exterior · contraportada y portada": "Exterior · back cover and front cover",
    "Interior · carta abierta": "Inside · open menu",
    "Anverso": "Front",
    "Reverso": "Back",
    "No se pudo cargar la carta o el tema de la sucursal.": "Could not load the menu or this branch’s theme.",
    "Reintentar": "Retry",
    "Tu carta todavía está vacía": "Your menu is still empty",
    "Añade categorías y platos activos al menú de esta sucursal para preparar su carta.": "Add categories and active dishes to the menu of this branch to prepare your menu.",
    "El dominio no corresponde a la sucursal seleccionada.": "The domain does not correspond to the selected branch."
  },
  "promotions": {
    "Menú del día": "Menu of the day",
    "Happy hour": "Happy hour",
    "Descuento porcentual": "Percentage discount",
    "Precio especial": "Special price",
    "2x1": "Buy one, get one free",
    "Platos concretos": "Specific dishes",
    "Categorías": "Categories",
    "Activa": "Active",
    "Inactiva": "Inactive",
    "Expirada": "Expired",
    "Crea una sucursal para gestionar promociones.": "Create a branch to manage promotions.",
    "Promociones": "Promotions",
    "Nueva promoción": "New promotion",
    "Activas y programadas": "Active and scheduled",
    "Aún no hay promociones.": "There are no promotions yet.",
    "Promoción no editable": "Promotion not editable",
    "Este tipo de promoción se conserva sin cambios, pero todavía no puede editarse desde este formulario.": "This promotion type remains unchanged, but cannot yet be edited from this form.",
    "Editar promoción": "Edit promotion",
    "Promoción": "Promotion",
    "Datos de la promoción": "Promotion details",
    "Nombre": "Name",
    "Descripción": "Description",
    "Estado": "Status",
    "Descuento": "Discount",
    "Tipo": "Type",
    "Alcance": "Scope",
    "Aplicar a": "Apply to",
    "Platos": "Dishes",
    "Porcentaje (0-100)": "Percentage (0-100)",
    "Unidades que lleva": "Units it carries",
    "Unidades que paga": "Units you pay",
    "Introduce un porcentaje entre 0 y 100": "Enter a percentage between 0 and 100",
    "Introduce un número entero mayor que 0": "Enter an integer greater than 0",
    "El nombre es obligatorio": "Name is required",
    "Selecciona al menos un destino": "Select at least one destination",
    "Indica un porcentaje": "Indicates a percentage",
    "Indica un precio": "Indicates a price",
    "Indica las unidades que lleva": "Indicates the units it carries",
    "Indica las unidades que paga": "Indicates the units paid",
    "Las unidades pagadas no pueden superar las compradas": "Units paid cannot exceed units purchased",
    "Promoción guardada.": "Promotion saved.",
    "Selecciona una promoción para editarla o crea una nueva.": "Select a promotion to edit it or create a new one.",
    "Activar {{name}}": "Activate {{name}}",
    "En platos con variantes de precio se aplica a la variante más barata.": "On dishes with price variants it applies to the cheapest variant."
  },
  "qr": {
    "Ocultar estilos": "Hide styles",
    "Estilos para imprimir": "Printable Styles",
    "Descargar SVG": "Download SVG",
    "Copiar URL": "Copy URL",
    "Descargar PNG": "Download PNG",
    "Archivo de descarga": "Download file",
    "Elige si el código abre la carta, la ficha directa de reseñas de Google o la tarjeta de fidelización.": "Choose whether the code opens the menu, the direct Google reviews page, or the loyalty card.",
    "Destino del QR": "QR Destination",
    "Tamaño del PNG": "PNG size",
    "Conecta la ficha de Google de esta sucursal para generar el QR de reseñas.": "Connect the Google listing of this branch to generate the reviews QR.",
    "Abrir ajustes de sucursal": "Open branch settings",
    "No se pudo cargar el tema de esta sucursal.": "Could not load this branch’s theme.",
    "Reintentar": "Retry",
    "Escanea para ver la carta": "Scan to see the menu",
    "Un QR listo para tu local": "A QR ready for your premises",
    "Elige una composición con el tema guardado de la sucursal y abre la impresión o guarda un PDF.": "Choose a layout using the branch’s saved theme, then print it or save a PDF.",
    "Imprimir / Guardar PDF": "Print/Save PDF",
    "Estilo de impresión": "Print Style",
    "No se pudieron cargar las tipografías. Recarga la página para volver a intentarlo.": "Fonts could not be loaded. Reload the page to try again.",
    "Preparando el QR y la identidad visual…": "Preparing the QR and visual identity…",
    "{{size}} × {{size}} px": "{{size}} × {{size}} px",
    "Carta": "Menu",
    "Reseñas de Google": "Google Reviews",
    "Fidelización": "Loyalty",
    "Minimal": "Minimal",
    "A6 blanco": "A6 white",
    "Branded": "Branded",
    "A6 con marca": "A6 branded",
    "Póster": "Poster",
    "A4 vertical": "A4 portrait",
    "Póster primario": "Primary Poster",
    "A4 con fondo primario": "A4 with primary background",
    "URL copiada.": "URL copied.",
    "Sin marca": "No branding",
    "Marca sobre blanco": "Branding on white",
    "Color de marca": "Brand colour",
    "Pequeño · 4 × 4 cm": "Small · 4 × 4 cm",
    "Mediano · 5 × 5 cm": "Medium · 5 × 5 cm",
    "Grande · 6 × 6 cm": "Large · 6 × 6 cm",
    "Pequeño · A6": "Small · A6",
    "Mediano · A5": "Medium · A5",
    "Grande · A4": "Large · A4",
    "Póster · A3": "Poster · A3",
    "Descargar el QR para otro diseño": "Download the QR for another design",
    "Solo el código, sin marca. Para enviarlo a tu diseñador o usarlo en otro documento.": "Just the code, without branding. Send it to your designer or use it in another document.",
    "Listo para imprimir.": "Ready to print.",
    "Selecciona al menos un destino para el folleto.": "Select at least one destination for the flyer.",
    "Indica una cantidad entre 1 y 300.": "Enter a quantity between 1 and 300.",
    "Esperando el tema de la sucursal. También puedes elegir «Sin marca».": "Waiting for the branch theme. You can also choose “No branding”.",
    "No se pudo preparar la impresión. Recarga la página para volver a intentarlo.": "Could not prepare the printout. Reload the page to try again.",
    "El contenido no cabe. Elige «Sin marca» o reduce los destinos del folleto.": "The content does not fit. Choose “No branding” or include fewer destinations on the flyer.",
    "QR para las mesas": "QR codes for tables",
    "Folletos y carteles": "Flyers & posters",
    "El mismo QR, tantas veces como necesites. Imprime en A4 y recorta por las guías.": "The same QR, as many times as you need. Print on A4 and cut along the guides.",
    "Tu carta, las reseñas y la fidelización, juntos o por separado en una misma página.": "Your menu, reviews and loyalty programme, together or separately on one page.",
    "Tamaño de cada QR": "Size of each QR",
    "Cantidad de QR": "Number of QRs",
    "Qué quieres incluir": "What to include",
    "Tamaño del papel": "Paper size",
    "Estilo": "Style",
    "Sin logo ni colores. El QR se imprime negro sobre blanco.": "No logo or colours. The QR prints in black on white.",
    "Usa el logo, los colores y las tipografías guardados de esta sucursal.": "Uses this branch’s saved logo, colours and fonts.",
    "No se pudo cargar el logo. Se imprimirá el nombre del local.": "The logo could not load. The venue name will be printed instead.",
    "Imprime a escala 100 %, sin encabezados. Para descargar, elige «Guardar como PDF».": "Print at 100% scale, without headers. To download, choose “Save as PDF”.",
    "Activa los gráficos de fondo para imprimir el color de marca.": "Turn on background graphics to print the brand colour.",
    "Vista previa de impresión": "Print preview",
    "Vista previa": "Preview",
    "{{quantity}} QR · A4 · {{pages}} pág.": "{{quantity}} QRs · A4 · {{pages}} pp.",
    "Tu carta en una página, lista para imprimir.": "Your menu on one page, ready to print.",
    "Idioma": "Language",
    "Premios": "Rewards",
    "Escanea y suma sellos en cada visita": "Scan to collect stamps on every visit",
    "¿Te ha gustado?": "Enjoyed it?",
    "Déjanos una reseña en Google": "Leave us a review on Google"
  },
  "theme": {
    "No disponible": "Not available",
    "Cargando": "Loading",
    "En directo": "Live",
    "Vista previa de la carta": "Menu preview",
    "Vista previa": "Preview",
    "La carta real, antes de publicar.": "Your actual menu, before it goes live.",
    "Vista previa móvil de la carta de {{host}}": "Mobile preview of {{host}}’s menu",
    "Cargando la carta…": "Loading the menu…",
    "No se pudo conectar con la carta pública.": "Could not connect to the public menu.",
    "Tema guardado.": "Theme saved.",
    "Crea una sucursal para personalizar su tema.": "Create a branch to customize your theme.",
    "El tema se guarda por dominio. Contacta con QMenut para asignarlo.": "Theme is saved by domain. Contact QMenut to assign it.",
    "Tema · {{domain}}": "Theme · {{domain}}",
    "Personalización": "Customization",
    "Guardar tema": "Save theme",
    "Identidad de la carta": "Menu branding",
    "Elige el estilo, los colores de marca y el mensaje de bienvenida.": "Choose the style, brand colors and welcome message.",
    "Plantilla": "Template",
    "Color primario": "Primary Color",
    "Color secundario": "Secondary Color",
    "Eslogan": "Slogan",
    "Tipografía": "Typography",
    "Combina una familia para los títulos con otra para el contenido de la carta.": "Pair one font family for headings with another for menu content.",
    "Tipografía de títulos": "Title Typography",
    "Tipografía de cuerpo": "Body Typography",
    "Fotografías": "Photos",
    "Estas opciones prevalecen sobre el estilo recomendado por la plantilla.": "These options override the style recommended by the template.",
    "Mostrar fotos en la carta": "Show photos in the menu",
    "Mostrar foto al abrir un plato": "Show dish photo when opened",
    "Bar de tapas": "Tapas bar",
    "Alta cocina": "Fine dining",
    "Cafetería": "Café",
    "Comida rápida": "Fast food",
    "Herencia": "Heritage",
    "La de la plantilla": "The one with the template",
    "La fuente no es válida para títulos": "Font is not valid for titles",
    "La fuente no es válida para el cuerpo": "Font is not valid for body",
    "Color no válido": "Invalid color",
    "Máximo 120 caracteres": "Maximum 120 characters"
  },
  "users": {
    "La cuenta ya existía en este restaurante, así que no se envió un acceso nuevo. Puedes reenviarlo desde Acciones.": "This account already existed for this restaurant, so no new access link was sent. You can resend it from Actions.",
    "La cuenta y la membresía se crearon, pero no se pudo enviar el acceso. Puedes reenviarlo desde Acciones.": "The account and membership were created, but access could not be submitted. You can forward it from Actions.",
    "Usuario añadido y acceso enviado.": "User added and access sent.",
    "Rol actualizado.": "Role updated.",
    "Membresía reactivada.": "Membership reactivated.",
    "Membresía desactivada.": "Membership disabled.",
    "No se pudo enviar el acceso. El último error ha quedado registrado para reintentar.": "Failed to send access. The last error has been recorded to retry.",
    "Acceso reenviado.": "Access link resent.",
    "Propietario": "Owner",
    "Administrador": "Administrator",
    "Equipo": "Equipment",
    "Activa": "Active",
    "Inactiva": "Inactive",
    "Enviado": "Sent",
    "Error": "Error",
    "Pendiente": "Pending",
    "Protegido": "Protected",
    "Acciones para {{name}}": "Actions for {{name}}",
    "Cambiar a {{role}}": "Change to {{role}}",
    "Desactivar": "Disable",
    "Reactivar": "Reactivate",
    "Reenviar acceso": "Resend access link",
    "Agregar usuario": "Add user",
    "Crea la cuenta y su acceso a este restaurante. La persona entrará solicitando un OTP, sin contraseña.": "Create an account and grant access to this restaurant. The person will sign in with a one-time code, without a password.",
    "Nombre": "Name",
    "Correo": "Mail",
    "Rol": "Role",
    "Se enviará un correo con el acceso para iniciar sesión.": "An email will be sent with login access.",
    "Cancelar": "Cancel",
    "Creando…": "Creating…",
    "Crear y enviar acceso": "Create and submit access",
    "Usuario": "User",
    "Membresía": "Membership",
    "Invitación": "Invitation",
    "Gestiona quién puede entrar al panel de este restaurante y con qué alcance.": "Manage who can enter this restaurant's panel and to what extent.",
    "Negocio": "Business",
    "Usuarios": "Users",
    "Accesos del restaurante": "Restaurant access",
    "persona": "person",
    "personas": "people",
    "Acciones": "Actions",
    "Usuarios y membresías del restaurante": "Restaurant Users and Memberships",
    "Aún no hay usuarios gestionables": "There are no manageable users yet",
    "Agrega una cuenta admin o staff para compartir el acceso al panel.": "Add an admin or staff account to share access to the panel.",
    "Cargando usuarios…": "Loading users…",
    "Actualizando usuarios…": "Updating users…",
    "Se bloqueará el acceso de": "Access will be blocked",
    "a este restaurante.": "to this restaurant.",
    "Desactivar membresía": "Deactivate membership",
    "Admin": "Admin",
    "Staff": "Staff",
    "Escribe un nombre": "Enter a name",
    "Escribe un correo válido": "Please enter a valid email"
  },
  "common": {
    "Autenticación rechazada.": "Authentication refused.",
    "No tienes permisos para realizar esta acción.": "You do not have permissions to perform this action.",
    "Se ha producido un error inesperado.": "An unexpected error has occurred.",
    "documentTitle": "QMenut Admin"
  },
  "images": {
    "Logo de la sucursal": "Branch logo",
    "Galería de la sucursal": "Branch gallery",
    "Imagen de categoría": "Category Image",
    "Imagen del plato": "Dish image",
    "Imagen del plato ({{name}})": "Dish ({{name}}) image",
    "Vuelve a seleccionar el archivo. Los demás cambios están guardados.": "Select the file again. The other changes are saved.",
    "Reintento de imagen iniciado.": "Image retry started.",
    "{{label}}: preparando…": "{{label}}: preparing…",
    "{{label}} actualizada": "{{label}} updated",
    "{{label}}: la imagen necesita atención": "{{label}}: image needs attention",
    "Reintentar": "Retry",
    "Pendiente de guardar": "Pending save",
    "Subiendo": "Uploading",
    "Procesando imagen": "Processing image",
    "Archivo recibido": "File received",
    "Error en la imagen": "Image error",
    "Selecciona una imagen JPEG, PNG o WebP.": "Select a JPEG, PNG, or WebP image.",
    "El archivo está vacío. Selecciona otra imagen.": "The file is empty. Select another image.",
    "La imagen no puede superar 25 MiB.": "The image cannot exceed 25 MiB.",
    "Selecciona una sola imagen.": "Select a single image.",
    "Arrastra tus fotos aquí": "Drag your photos here",
    "Arrastra aquí una imagen": "Drag an image here",
    "JPEG, PNG o WebP · máximo 25 MiB por imagen": "JPEG, PNG or WebP · maximum 25 MiB per image",
    "{{action}}: {{label}}": "{{action}}: {{label}}",
    "Foto {{index}}": "Photo {{index}}",
    "Foto movida a la posición {{index}}{{cover}}.": "Photo moved to position {{index}}{{cover}}.",
    ", portada": ", cover",
    "Foto {{index}} quitada. Los cambios se aplican al guardar.": "Photo {{index}} removed. Changes take effect when you save.",
    "Elegir fotos": "Choose photos",
    "Añade fotos del espacio, la terraza o tus platos.": "Add photos of the space, the terrace or your dishes.",
    "Has alcanzado el máximo de": "You have reached the maximum",
    "fotos. Quita una para añadir otra.": "photos. Remove one to add another.",
    "Foto {{index}}{{cover}}: {{name}}": "Photo {{index}}{{cover}}: {{name}}",
    "Reordenar {{name}}. Arrastra, o usa las flechas para moverla.": "Reorder {{name}}. Drag it or use the arrows to move it.",
    "Portada": "Cover",
    "Usar {{name}} como portada": "Use {{name}} as the cover",
    "Usar como portada": "Use as cover",
    "Reemplazar {{name}}": "Replace {{name}}",
    "Reemplazar": "Replace",
    "Quitar {{name}}": "Remove {{name}}",
    "Quitar": "Remove",
    "La primera foto será la portada. Los cambios se aplican al guardar.": "The first photo will be the cover. Changes are applied when saving.",
    "de": "",
    "Seleccionar imagen": "Select image",
    "Quitar: {{label}}": "Remove: {{label}}",
    "Los cambios se aplican al guardar.": "Changes are applied when saving.",
    "No se pudo preparar la imagen. Selecciona otra imagen.": "Could not prepare image. Select another image.",
    "No se pudo obtener la URL de subida. Pulsa Guardar para reintentar.": "Could not get the upload URL. Press Save to retry.",
    "No se pudo subir la imagen. Pulsa Guardar para reintentar.": "Could not upload image. Press Save to retry.",
    "No se pudo inicializar el borrador de imagen.": "The image draft could not be initialized.",
    "La galería admite hasta {{maximum}} imágenes.": "The gallery supports up to {{maximum}} images.",
    "Ajustar logo": "Adjust logo",
    "Arrastra para centrar y usa el zoom para encuadrar el logo.": "Drag to center and use zoom to frame the logo.",
    "Zoom": "Zoom",
    "Cancelar": "Cancel",
    "Aplicar": "Apply",
    "No se pudo recortar la imagen. Prueba con otra.": "Could not crop the image. Try another one."
  },
  "notifications": {
    "Aceptado automáticamente": "Accepted automatically",
    "Activando…": "Turning on…",
    "Activar en este dispositivo": "Turn on for this device",
    "Caducado": "Expired",
    "Cancelado por el cliente": "Cancelled by the guest",
    "Canje pendiente": "Redemption waiting",
    "Cargando notificaciones": "Loading notifications",
    "Crea una sucursal para recibir avisos.": "Create a branch to get notifications.",
    "Desactivar": "Turn off",
    "En iPhone y iPad, añade el panel a la pantalla de inicio (Compartir → Añadir a inicio) y activa las notificaciones desde allí.": "On iPhone and iPad, add the dashboard to your home screen (Share → Add to Home Screen) and turn notifications on from there.",
    "Este dispositivo recibe avisos de las sucursales marcadas.": "This device gets notified for the checked branches.",
    "Este navegador no admite notificaciones push.": "This browser does not support push notifications.",
    "Guardar sucursales": "Save branches",
    "Instala el panel": "Install the dashboard",
    "Lo que necesita tu atención en esta sucursal, de los últimos 30 días.": "What needs your attention at this branch, from the last 30 days.",
    "Marcar todo como leído": "Mark all as read",
    "No hay notificaciones. Los avisos nuevos aparecerán aquí.": "No notifications. New ones will show up here.",
    "Notificaciones": "Notifications",
    "Notificaciones bloqueadas": "Notifications blocked",
    "Notificaciones en este dispositivo": "Notifications on this device",
    "Notificaciones, {{count}} sin leer": "Notifications, {{count}} unread",
    "Permite las notificaciones de este sitio en los ajustes del navegador y vuelve a intentarlo.": "Allow notifications for this site in your browser settings and try again.",
    "Rechazado": "Rejected",
    "Rechazado por {{name}}": "Rejected by {{name}}",
    "Recibe un aviso en este dispositivo cuando haya algo que atender.": "Get notified on this device when something needs your attention.",
    "Reintentar": "Try again",
    "Resuelto": "Handled",
    "Sin leer": "Unread",
    "Sucursales": "Branches",
    "Validado": "Validated",
    "Validado por {{name}}": "Validated by {{name}}",
    "{{reward}} · {{cost}} sellos": "{{reward}} · {{cost}} stamps",
    "Solicitud de {{count}} sellos": "Request for {{count}} stamps",
    "Solicitud de sellos": "Stamp request",
    "Aceptado": "Accepted",
    "Aceptado por {{name}}": "Accepted by {{name}}",
    "Reserva cancelada": "Reservation cancelled",
    "{{day}} · {{time}} · {{count}} personas": "{{day}} · {{time}} · {{count}} guests",
    "Nueva reserva": "New reservation",
    "¿Activar notificaciones en este dispositivo?": "Turn on notifications on this device?",
    "Ahora no": "Not now",
    "Enviar prueba": "Send a test",
    "Prueba enviada. Debería llegar en unos segundos.": "Test sent. It should arrive in a few seconds.",
    "No se pudo enviar. Desactiva y vuelve a activar las notificaciones.": "Could not send it. Turn notifications off and on again."
  },
  "messaging": {
    "Enviar plantilla": "Send template",
    "Plantilla": "Template",
    "Teléfono (E.164)": "Phone (E.164)",
    "Cliente": "Customer",
    "Restaurante": "Restaurant",
    "Fecha": "Date",
    "Hora": "Time",
    "Personas": "Guests",
    "Enviar": "Send",
    "Conversación": "Conversation",
    "Conversaciones": "Conversations",
    "La ventana de 24 h está cerrada: solo se pueden enviar plantillas.": "The 24 h window is closed: only templates can be sent.",
    "Respuesta": "Reply",
    "Responder": "Reply",
    "Mensajería": "Messaging",
    "MSG_WORKER no está configurado en este entorno.": "MSG_WORKER is not configured in this environment."
  },
  "reservations": {
    "1 persona": "1 person",
    "1 reserva": "1 reservation",
    "Aceptar reservas desde la carta": "Take reservations from the menu",
    "Ajustes": "Settings",
    "Ajustes guardados.": "Settings saved.",
    "Antelación mínima (horas)": "Minimum notice (hours)",
    "Añade al menos una hora para activar las reservas": "Add at least one time to turn reservations on",
    "Añadir hora": "Add time",
    "Cada reserva cuenta como una, sea cual sea el número de personas; a partir del máximo, la carta invita a llamar. Deja mesas para quien llega sin reservar y cierra una hora cuando se llene la sala.": "Each reservation counts as one, whatever the party size; above the maximum, the menu asks guests to call. Leave tables for walk-ins and close a time when the room fills up.",
    "Cancelada": "Cancelled",
    "Cancelar la reserva de {{name}}": "Cancel {{name}}'s reservation",
    "Cancelar reserva": "Cancel reservation",
    "Cargando reservas": "Loading reservations",
    "Cerrar el día": "Close the day",
    "Cerrar la hora": "Close the time",
    "Cerrar reservas": "Close reservations",
    "Cierre añadido.": "Closure added.",
    "Cierres": "Closures",
    "Cliente anónimo": "Anonymous guest",
    "Confirmada": "Confirmed",
    "Copiar a todos los días": "Copy to every day",
    "Copiar las horas del {{day}} a todos los días": "Copy {{day}}'s times to every day",
    "Crea una sucursal antes de configurar las reservas.": "Create a branch before setting up reservations.",
    "Día": "Day",
    "Día anterior": "Previous day",
    "Día siguiente": "Next day",
    "Días que se puede reservar por adelantado": "Days guests can book ahead",
    "Email": "Email",
    "Escribe un número entero": "Enter a whole number",
    "Fecha": "Date",
    "Guardar ajustes": "Save settings",
    "Hora": "Time",
    "Hora de {{day}}": "{{day}} time",
    "Horas de reserva": "Reservation times",
    "Hoy": "Today",
    "Indica un número entre {{min}} y {{max}}": "Enter a number between {{min}} and {{max}}",
    "La reserva de {{name}} para el {{when}} se cancela, la mesa queda libre y el cliente recibe un email. No se puede deshacer.": "{{name}}'s reservation for {{when}} is cancelled, the table is freed and the guest gets an email. This can't be undone.",
    "La reserva queda hecha al momento. El cliente recibe un email y un recordatorio con un enlace para confirmar o cancelar; si no confirma, mantiene su mesa.": "Reservations are booked instantly. The guest gets an email and a reminder with a link to confirm or cancel; if they don't confirm, they keep their table.",
    "Las horas a las que se puede llegar cada día, en la hora del restaurante.": "The arrival times guests can book each day, in the restaurant's time.",
    "Máximo de personas por reserva": "Maximum party size",
    "No hay cierres programados.": "No closures scheduled.",
    "No hay reservas este día.": "No reservations on this day.",
    "Para festivos, eventos privados o reservas tomadas por teléfono. Las reservas que ya existen no se cancelan.": "For holidays, private events or bookings taken by phone. Existing reservations aren't cancelled.",
    "Próximos cierres": "Upcoming closures",
    "Quitar": "Remove",
    "Quitar {{time}} del {{day}}": "Remove {{time}} from {{day}}",
    "Reabrir": "Reopen",
    "Reabrir {{closure}}": "Reopen {{closure}}",
    "Recordatorio por email (horas antes)": "Email reminder (hours before)",
    "Reintentar": "Try again",
    "Reserva de {{name}} cancelada.": "{{name}}'s reservation cancelled.",
    "Reservas": "Reservations",
    "Reservas online": "Online reservations",
    "Reservas online por hora": "Online reservations per time",
    "Secciones de reservas": "Reservation sections",
    "Sin confirmar": "Not confirmed",
    "Sin reservas": "No reservations",
    "Teléfono": "Phone",
    "Todo el día": "All day",
    "Volver": "Back",
    "todo el día": "all day",
    "{{count}} personas": "{{count}} people",
    "{{count}} reservas": "{{count}} reservations",
    "{{held}} de {{capacity}} reservas": "{{held}} of {{capacity}} reservations",
    "¿Cancelar esta reserva?": "Cancel this reservation?"
  }
}
